
export default class PhoneFormatter {

    static formatForDisplay(phone: string | null | undefined): string {
        if (!phone) return "";

        // Remove all non-digit characters
        const digitsOnly = phone.replace(/\D/g, "");

        // Handle 11-digit numbers starting with 1 (US country code)
        let digits = digitsOnly;
        if (digits.length === 11 && digits.startsWith("1")) {
            digits = digits.substring(1);
        }

        // Format as (XXX) XXX-XXXX if we have exactly 10 digits
        if (digits.length === 10) {
            const areaCode = digits.substring(0, 3);
            const prefix = digits.substring(3, 6);
            const lineNumber = digits.substring(6, 10);
            return `(${areaCode}) ${prefix}-${lineNumber}`;
        }

        // Return original value if not a standard US number
        return phone;
    }

    static formatForTwilio(phone: string | null | undefined): string {
        if (!phone) return "";

        // Remove all non-digit characters
        const digitsOnly = phone.replace(/\D/g, "");

        // Handle different lengths
        if (digitsOnly.length === 10) {
            // 10 digits - add +1
            return `+1${digitsOnly}`;
        } else if (digitsOnly.length === 11 && digitsOnly.startsWith("1")) {
            // 11 digits starting with 1 - add +
            return `+${digitsOnly}`;
        }

        // For other cases, try to preserve original format if it had a +
        if (phone.startsWith("+")) {
            return `+${digitsOnly}`;
        }

        // Return digits only for non-standard formats
        return digitsOnly || phone;
    }
}

export function formatPhoneFilter(
    phone: string | null | undefined
): string {
    return PhoneFormatter.formatForDisplay(phone);
}

export function formatPhoneTwilioFilter(
    phone: string | null | undefined
): string {
    return PhoneFormatter.formatForTwilio(phone);
}
